export const APP_URL = "http://localhost:3000";
export const FRONTEND_VERSION = "0.0.1";